import React, { useState } from "react";
import { supabase } from "../../supabaseClient"; // adjust path as needed

import XLogo from "./images/X_logo_black_256px.png";

export default function EmailGrabber({ buttonLabel = "Register for updates" }) {
	const [email, setEmail] = useState("");
	const [status, setStatus] = useState("");
	const [loading, setLoading] = useState(false);

	const isValidEmail = (email) => {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return regex.test(email);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!isValidEmail(email)) {
			setStatus("Please enter a valid email.");
			return;
		}

		setLoading(true);
		setStatus("");

		try {
			// Check if email already exists
			const { data: existing, error: selectError } = await supabase.from("Email_list").select("id").eq("email", email).single();
			console.log("Existing email check:", existing, selectError);

			if (selectError && selectError.code !== "PGRST116") {
				throw selectError;
			}

			if (existing) {
				setStatus("You are already on the list.");
				setLoading(false);
				return;
			}

			const { error: insertError } = await supabase.from("Email_list").insert([{ email }]);

			if (insertError) {
				throw insertError;
			}

			setStatus("Thanks! You are on the list.");
			setEmail("");
		} catch (error) {
			console.error("Submission error:", error.message);
			setStatus("Something went wrong. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	const isSuccess = status === "Thanks! You are on the list.";
	const statusColor = isSuccess ? "text-black" : "text-black";

	return (
		<div className="font-sans flex flex-col items-center justify-center lg:mx-96 md:mx-4 py-4 mb-32 rounded-xl bg-white border border-neutral-300 hover:shadow-md transition">
			<form className="flex flex-col items-center justify-center gap-3 w-full max-w-md" onSubmit={handleSubmit}>
				{/* Only show input/button if not successful */}
				{!isSuccess && (
					<div className="flex flex-row items-center justify-center gap-4 w-full">
						<input
							type="email"
							required
							placeholder="Enter your E-mail"
							className="flex-1 px-4 py-3 rounded-xl bg-white text-gray-900 placeholder-gray-700 focus:outline-none shadow-inner border border-gray-300"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							disabled={loading}
						/>
						<button
							type="submit"
							className="bg-sky-300 hover:bg-sky-400 transition-colors text-black min-w-52 py-3 rounded-xl font-semibold shadow-lg border border-sky-700 hover:border-sky-800"
							disabled={loading}
						>
							{loading ? "Submitting..." : buttonLabel}
						</button>
					</div>
				)}

				{/* Status/Error/Success message below input or alone on success */}
				{status && <p className={`text-xl mt-2 text-center ${statusColor}`}>{status}</p>}

				{/* Show info text only if not successful */}
				{!isSuccess && <p className="text-xs text-neutral-500 text-center">No spam, just project news.</p>}
				<div className="flex flex-col items-center justify-center gap-2">
					<div className="flex flex-row items-center justify-center gap-1">
						<p className="text-base text-neutral-500 text-center">To have the latest news on the project, join on</p>
						<img src={XLogo} alt="X (Twitter) logo" className="w-4 h-auto" style={{ display: "inline", verticalAlign: "middle" }} />
					</div>
					<a href="https://x.com/MrDotNobi" target="_blank" rel="noopener noreferrer">
						<button className="bg-sky-300 hover:bg-sky-400 text-black px-6 py-3 rounded-xl font-semibold flex items-center gap-2 transition border border-sky-700 hover:border-sky-800" type="button">
							Follow on
							<img src={XLogo} alt="X (Twitter) logo" className="w-4 h-4" />
						</button>
					</a>
				</div>
			</form>
		</div>
	);
}
